import { render } from "./DisbursementModal.vue?vue&type=template&id=63f05b7c&scoped=true"
import script from "./DisbursementModal.vue?vue&type=script&lang=js"
export * from "./DisbursementModal.vue?vue&type=script&lang=js"

import "./DisbursementModal.vue?vue&type=style&index=0&id=63f05b7c&lang=stylus&scoped=true"
import "./DisbursementModal.vue?vue&type=style&index=1&id=63f05b7c&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f05b7c"]])

export default __exports__